import { Component, ViewEncapsulation } from '@angular/core';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { merge, Observable } from 'rxjs';
import { ToastNotificationService } from '../../core/toast-notification.service';
import { UIBlockingService } from '../../core/ui-blocking.service';
import { DumbDashboardInfo } from './DTOs/dumb-dashboard-info';
import { MemberDashboardService } from './member-dashboard.service';
import { AuthService } from '../../core/auth.service';

@Component({
  selector: 'app-member-dashboard',
  templateUrl: './member-dashboard.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})
export class MemberDashboardComponent {
  constructor(private memberDashboardService: MemberDashboardService
    , private blockUI: UIBlockingService
    , private notificationService: ToastNotificationService
    , private modalService: NgbModal
    , private authService: AuthService) {

  }
  info: DumbDashboardInfo = new DumbDashboardInfo();
    userFirstName: string = "";
    membershipLevel: string = "";
    hasLetterOfIntroPerk: boolean = false;
    hasAds: boolean = false;

    ngOnInit() {
        this.hasLetterOfIntroPerk = this.authService.hasLetterOfIntroPerk();
        this.hasAds = this.authService.hasAdsPerk();
      this.userFirstName = localStorage.getItem('userFirstName');
      this.membershipLevel = localStorage.getItem('membershipLevel');

    var observablesMerged = merge(this.getDashboardInfoObservable());
    this.blockUI.start();
    observablesMerged.subscribe(
      {
        next: (data) => {
          this.info = data
        },
        error: (err) => {
            this.notificationService.error(err.error.message);
          this.blockUI.stop();
          console.log(err)
        },
        complete: () => {
          this.blockUI.stop();
        }
      });
  }

  getDashboardInfoObservable(): Observable<DumbDashboardInfo> {
    return this.memberDashboardService
      .getDashboardInfo();
  }
}
